var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 11.5H9.83317V13.1667H8.1665V11.5ZM8.1665 4.83335H9.83317V9.83335H8.1665V4.83335ZM8.9915 0.666687C4.3915 0.666687 0.666504 4.40002 0.666504 9.00002C0.666504 13.6 4.3915 17.3334 8.9915 17.3334C13.5998 17.3334 17.3332 13.6 17.3332 9.00002C17.3332 4.40002 13.5998 0.666687 8.9915 0.666687ZM8.99984 15.6667C5.3165 15.6667 2.33317 12.6834 2.33317 9.00002C2.33317 5.31669 5.3165 2.33335 8.99984 2.33335C12.6832 2.33335 15.6665 5.31669 15.6665 9.00002C15.6665 12.6834 12.6832 15.6667 8.99984 15.6667Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d1fe6082a4f0bea6425d72c135accfef.svg";
export { ForwardRef as ReactComponent };